const ITEMS = [
  "Workspace architecture",
  "Visual automation",
  "AI stack",
  "Quiet operations",
  "Compound time",
  "Calm companies",
  "One-person studios",
  "Systems over hustle",
  "Pinned by 2,400+ founders",
];

export default function Marquee() {
  // duplicate so the animation can translate -50% seamlessly
  const loop = [...ITEMS, ...ITEMS];

  return (
    <div
      data-testid="marquee-strip"
      className="relative border-y border-subtle bg-card-surface py-5 overflow-hidden"
      aria-hidden="true"
    >
      <div className="marquee-track gap-12">
        {loop.map((t, i) => (
          <div key={`${t}-${i}`} className="flex items-center gap-12 shrink-0">
            <span className="font-display text-primary text-2xl md:text-3xl font-light tracking-tight whitespace-nowrap">
              {t}
            </span>
            <span
              className="block w-1.5 h-1.5 rounded-full shrink-0"
              style={{ background: "var(--accent)" }}
            />
          </div>
        ))}
      </div>
      {/* Edge fades */}
      <div
        className="pointer-events-none absolute inset-y-0 left-0 w-24"
        style={{
          background:
            "linear-gradient(to right, var(--page), transparent)",
        }}
      />
      <div
        className="pointer-events-none absolute inset-y-0 right-0 w-24"
        style={{
          background:
            "linear-gradient(to left, var(--page), transparent)",
        }}
      />
    </div>
  );
}
